import * as Scrivito from "scrivito";
import { Helmet } from "react-helmet-async";
import setLanguage from "^/utils/setLanguage";
import { jsonLd } from "^/Widgets/SchemaWidget/Schemas";
import { SchemaWidgetComponent } from "^/Widgets/SchemaWidget/SchemaWidgetComponent";
import { richSnippetsJSONCourse } from "../../richSnippetsJSON";
import courseDetailsMapping from "../../utils/courseDetailsMapping";

function CoursePageComponent({ page }) {
  const json = jsonLd.EducationalOccupationalProgram(page, page);

  const mapping = courseDetailsMapping();
  setLanguage(page);

  return (
    <>
      <Helmet>
        <script type="application/ld+json" defer>
          {richSnippetsJSONCourse(page, mapping)}
        </script>
      </Helmet>
      <Scrivito.ContentTag
        tag="div"
        content={page}
        attribute="body"
        className="pb-4"
        role="main"
      />
      <SchemaWidgetComponent
        type="EducationalOccupationalProgram"
        json={json}
      />
    </>
  );
}

Scrivito.provideComponent("CoursePage", Scrivito.connect(CoursePageComponent));
